/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { Toggle } from '@carbon/react';
import { useIntl, defineMessages } from 'react-intl';

import styles from './ItemEnable.module.scss';

type PropsTest = {
    enabled: boolean;
    id: string;
    disabled: boolean;
};

const ItemEnable = ({
    enabled,
    id,
    disabled = false,
}: PropsTest) => {
    const intl = useIntl();
    const onToggle = () => {

    };

    return (
        <div className={styles.container}>
            <Toggle
                id={id}
                className={styles.toggle}
                disabled={disabled}
                labelA={intl.formatMessage(messages.labelA)}
                labelB={intl.formatMessage(messages.labelB)}
                toggled={enabled}
                onToggle={onToggle}
            />
        </div>
    );
};

export default ItemEnable;

const messages = defineMessages({
    labelA: {
        id: 'src.Components.Common.Interactions.ItemEnable.labelA',
        defaultMessage: 'Wyłączone',
    },
    labelB: {
        id: 'src.Components.Common.Interactions.ItemEnable.labelB',
        defaultMessage: 'Włączone',
    },
});
